module.exports = __webpack_public_path__ + "static/images/components/ButtonInbox/images/button-inbox.f9965ea5.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonInbox/images/button-inbox.png
// module id = 2570
// module chunks = 11